import React from "react";
import useFetchData from "../../../hooks/useFetchData";
import SingleSelectBox from "../../../components/FormComponents/SingleSelectBox";

const SubFormSelection = ({ value, onChange, tableID }) => {
  const { data: allSubforms, loading, error } = useFetchData("/subform");

  const handleChangeSubForm = (value) => {
    if (!value) {
      onChange({ sub_form: "", components: [] });
      return;
    }
    const subform = allSubforms.find((s) => s.id === value);
    onChange({ sub_form: value, components: subform.config.fields || [] });
  };

  if (loading) {
    return null;
  }
  if (error) {
    return <div>{error.message}</div>;
  }

  const subFormOptions = allSubforms
    .filter((subform) => subform.config.table_id === tableID)
    .map((subForm) => ({
      id: subForm.id,
      name: subForm.name
    }));
  return (
    <div className="builder_form">
      <SingleSelectBox
        selectedData={value}
        options={subFormOptions}
        onChange={(obj) => handleChangeSubForm(obj.id)}
        placeholder="Select Sub Form"
        label="Select Sub Form"
      />
    </div>
  );
};

export default SubFormSelection;
